import { defineSound, ensureReady } from '@web-kits/audio';
import log from 'loglevel';

import {
  AUDIO_CONTEXT_RUNNING_STATE,
  MINIMAL_NOTIFICATION_SOUND,
} from '../../utils/constants/suggestionTabAlerts';

let audioContext: AudioContext | null = null;
let playSound: ReturnType<typeof defineSound> | null = null;

export async function unlockSuggestionAudio(): Promise<void> {
  try {
    audioContext = await ensureReady();
  } catch (err) {
    log.warn('unlockSuggestionAudio', err);
  }
}

export function isSuggestionAudioUnlocked(): boolean {
  return audioContext?.state === AUDIO_CONTEXT_RUNNING_STATE;
}

export function playSuggestionSound(): void {
  try {
    playSound ??= defineSound(MINIMAL_NOTIFICATION_SOUND);
    playSound();
  } catch (err) {
    log.warn('playSuggestionSound', err);
  }
}
